import React, { FC } from 'react'
import { InputGroup, OverlayTrigger, Tooltip } from 'react-bootstrap'
import Form from 'react-bootstrap/Form'
import '../../kyc/kycStyle.css'
import HoverIcon from '../../Icons/HoverIcon'
import './FormInput.css'

import { FaStarOfLife } from 'react-icons/fa'

interface FormInputProps {
  placeHolderText?: string
  labelText?: string
  mutedText?: string
  toolTipText?: string
  controlId?: string
  required?: boolean
  autoFocus?: boolean
  inputGroupClassName?: string
  value: string
  onChangeHandler: (value: string) => void
  className?: string
  style?: React.CSSProperties
  onSubmit?: (e?: React.FormEvent<HTMLInputElement>) => void
  disabled?: boolean
}

export const FormInput: FC<FormInputProps> = ({
  placeHolderText,
  labelText,
  mutedText,
  toolTipText,
  controlId,
  required,
  inputGroupClassName,
  onChangeHandler,
  className,
  style,
  onSubmit,
  disabled,
  ...rest
}) => {
  return (
    <>
      <Form.Group
        style={{
          maxWidth: '430px',
          ...style,
        }}
        className={className}
        controlId={controlId}
      >
        <InputGroup className={inputGroupClassName}>
          <Form.Control
            type="input"
            className="custom-input"
            disabled={disabled}
            onChange={(e) => {
              onChangeHandler(e.target.value)
            }}
            // onSubmit={onSubmit}
            placeholder={placeHolderText}
            onKeyDownCapture={(e) => {
              e.code === 'Enter' && onSubmit && onSubmit()
            }}
            {...rest}
          />
          {mutedText && (
            <Form.Text className="text-muted">{mutedText}</Form.Text>
          )}
          {toolTipText && (
            <OverlayTrigger
              trigger="hover"
              placement="right"
              overlay={
                <Tooltip id="tooltip-reference" className="custom-tooltip">
                  {toolTipText}
                </Tooltip>
              }
            >
              <div>
                <HoverIcon className="pullRight" />
              </div>
            </OverlayTrigger>
          )}
        </InputGroup>
      </Form.Group>
    </>
  )
}
export default FormInput
